module.exports = __webpack_public_path__ + "static/media/student-summary-record-prev.c65dfa99.png";